import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledDesktopHeaderMenuItems = styled(Box)(({ theme }: { theme: any }) => ({
  display: 'flex',
  alignItems: 'stretch',
  width: '100%',
  minWidth: 0,
  '& .header-menu__container': {
    margin: 0,
    display: 'flex',
    alignItems: 'stretch',
    minWidth: 0,
  },
  '& .header-menu__item': {
    display: 'inline-flex',
    flexShrink: 0,
    minHeight: '38px',
    position: 'relative',
    '&:hover .header-menu__item-link.active': {
      '& ~ .header-menu__subitems': {
        display: 'block',
      },
    },
    '& .header-menu__subitems': {
      display: 'none',
      position: 'absolute',
      background: theme.vars.palette.background.paper,
      top: 'calc(100% - 22px)',
      left: 0,
      boxShadow: theme.shadows[3],
      borderRadius: 6,
      minWidth: 180,
      zIndex: 1,
      '& .MuiListItem-root': {
        color: theme.vars.palette.text.primary,
        padding: '9px 16px',
        margin: 0,
        whiteSpace: 'nowrap',
        '&:hover': { backgroundColor: theme.vars.palette.action.hover },
      },
    },
  },
  '& .header-menu__item-link': {
    padding: '21px 15px',
    display: 'inline-flex',
    alignItems: 'center',
    color: theme.vars.palette.text.primary,
    textDecoration: 'none',
    flexDirection: 'column',
    justifyContent: 'space-between',
    border: '2px solid transparent',
    background: 'transparent',
    font: 'inherit',
    cursor: 'pointer',
    '&:hover': { backgroundColor: theme.vars.palette.action.hover },
    '&.active': { borderBottomColor: theme.vars.palette.text.primary },
    '&::after': {
      content: 'attr(data-text)',
      height: 0,
      visibility: 'hidden',
      overflow: 'hidden',
      userSelect: 'none',
      pointerEvents: 'none',
      fontWeight: 600,
      '@media speech': { display: 'none' },
    },
  },
}));

export default StyledDesktopHeaderMenuItems;
